import React from "react";
import { Navigate } from "react-router-dom";
import { isSupervisor } from "../../services/userService";

const AdminProtectedRoute = ({ children }) => {
    const isUserSupervisor = isSupervisor();
    
    if (!isUserSupervisor) {
        // Ha nincs supervisor jogosultság, visszairányítjuk a főoldalra
        return <Navigate to="/Home" replace />;
    }
    
    return children;
};

export default AdminProtectedRoute;